import React from 'react';

export const Ellipsis: React.FC = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.3354 7.99998C12.3354 8.18415 12.1861 8.33345 12.0019 8.33345C11.8178 8.33345 11.6685 8.18415 11.6685 7.99998C11.6685 7.8158 11.8178 7.6665 12.0019 7.6665C12.1861 7.6665 12.3354 7.8158 12.3354 7.99998"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.33345 7.99998C8.33345 8.18415 8.18415 8.33345 7.99998 8.33345C7.8158 8.33345 7.6665 8.18415 7.6665 7.99998C7.6665 7.8158 7.8158 7.6665 7.99998 7.6665C8.18415 7.6665 8.33345 7.8158 8.33345 7.99998"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.33198 7.99998C4.33198 8.18415 4.18268 8.33345 3.99851 8.33345C3.81434 8.33345 3.66504 8.18415 3.66504 7.99998C3.66504 7.8158 3.81434 7.6665 3.99851 7.6665C4.18268 7.6665 4.33198 7.8158 4.33198 7.99998"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
